import { decamelizeKeys } from 'humps';
import { request } from './helper';
import { trackAnalyticsEvent } from './analytics';
import { ANALYTICS_EVENTS } from '../lib/analytics';
import { stripEmojis } from '../lib/helpers';
import { CHECKR_BFF_API_BASE } from '../constants';

/*
 * Action Types
 */

export const SUBMIT_DISPUTE_REQUEST = 'SUBMIT_DISPUTE_REQUEST';
export const submitDisputeRequest = () => ({ type: SUBMIT_DISPUTE_REQUEST });

export const SUBMIT_DISPUTE_SUCCESS = 'SUBMIT_DISPUTE_SUCCESS';
export const submitDisputeSuccess = reportId => ({
  type: SUBMIT_DISPUTE_SUCCESS,
  reportId,
});

export const SUBMIT_INTAKE_SUCCESS = 'SUBMIT_INTAKE_SUCCESS';
export const submitIntakeSuccess = () => ({ type: SUBMIT_INTAKE_SUCCESS });

/*
 * Actions
 */

export const submitDispute = (values, jwt) => (dispatch, getState) => {
  dispatch(submitDisputeRequest());

  values.disputedItems.forEach(item => {
    item.explanation = stripEmojis(item.explanation);
  });

  const submissionValues = {
    report: values.report,
    disputedItems: values.disputedItems,
    userActions: values.userActions,
  };

  const portalToken = getState().portal?.token;
  const options = {
    method: 'POST',
    body: JSON.stringify({
      ...decamelizeKeys(submissionValues),
      ...(!jwt && portalToken ? { token: portalToken } : {}),
    }),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(jwt && { Authorization: `Bearer ${jwt}` }),
    },
  };

  return request(`${CHECKR_BFF_API_BASE}/dispute_intake`, options).then(
    json => {
      dispatch(
        json.result === 'intake'
          ? submitIntakeSuccess()
          : submitDisputeSuccess(values.report.id),
      );
      dispatch(
        trackAnalyticsEvent(ANALYTICS_EVENTS.REPORT_ERROR_BUTTON_CLICKED),
      );
    },
  );
};
